import React, { useContext } from 'react';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { Typography } from '@one-thd/sui-atomic-components';
import { EMPTY_LISTS_B2B_IMAGE_SRC_DESKTOP, EMPTY_LISTS_B2B_IMAGE_SRC_MOBILE } from '../../constants/emptyListsAssets';

const EmptyMessagingB2B = () => {
  const { channel } = useContext(ExperienceContext);
  const isMobile = channel === 'mobile';
  const bannerTextAlignment = isMobile ? 'center' : 'left';
  const bannerCssClasses = isMobile
    ? 'sui-pr-4 sui-pl-4 sui-pb-6 sui-flex sui-flex-col sui-justify-center sui-gap-4'
    : 'sui-p-4 sui-flex sui-items-center sui-justify-between';

  return (
    <div className="sui-mt-6 sui-flex sui-flex-col sui-gap-8">
      <div className="sui-flex sui-flex-col sui-gap-3">
        <Typography variant="body-base" weight="bold">You haven&apos;t saved any lists.</Typography>
        <Typography>Use lists to stay organized and save frequently purchased products.</Typography>
      </div>
      <div
        className={`sui-paper sui-paper-outlined sui-mt-7 sui-border-1 sui-bg-inactive
          sui-border-solid ${bannerCssClasses}`}
      >
        { (isMobile) && (
          <picture className="sui-flex sui-justify-center">
            <img
              width="343"
              height="242"
              src={EMPTY_LISTS_B2B_IMAGE_SRC_MOBILE}
              alt="empty lists placeholder"
              data-testid="empty-lists-b2b-mobile-image"
            />
          </picture>
        ) }
        <div className="sui-flex sui-flex-col sui-gap-4">
          <Typography align={bannerTextAlignment} variant="h2" weight="display">
            GET STARTED {isMobile && (<br />) } WITH LISTS
          </Typography>
          <Typography align={bannerTextAlignment}>
            Find the &apos;Add to List&apos; button on item {isMobile && <br />}
            pages to {!isMobile && <br />} initiate your list experience.
          </Typography>
        </div>
        { (!isMobile) && (
          <img
            width="445"
            height="162.23"
            src={EMPTY_LISTS_B2B_IMAGE_SRC_DESKTOP}
            alt="empty lists placeholder"
            data-testid="empty-lists-b2b-desktop-image"
          />
        ) }
      </div>
    </div>
  );
};

export { EmptyMessagingB2B };

EmptyMessagingB2B.displayName = 'UserListsEmptyMessagingB2B';

EmptyMessagingB2B.propTypes = {};

EmptyMessagingB2B.defaultProps = {};
